import React, { Component } from "react";
import { connect } from "react-redux";

import PropTypes from "prop-types";
import {
	fetchClientDetail,
	setClientLifecycleStatus,
	deactivateClient,
	activateClient,
} from "../actions/clientActions";
import {
	getClientLifecycleStatusObject,
	NORMAL_LIFECYCLE_STATUS,
	TRASH_LIFECYCLE_STATUS,
} from "../utilities/lifecycleStatus";
import { fetchMattersList } from "../actions/matterActions";

import { DropDownButtonWithRouter } from "./DropDownButton";
import TextGrid from "./TextGrid";
import MaximumItemsList from "./MaximumItemsList";

import MaterialTabs from "./MaterialTabs";
import { capitalize } from "../utilities/utilities";

import MattersList from "./MattersList";

import { TrashBinMessage } from "./Utils/UnderSubHeaderWarningMessages";
import { IconBriefcase } from "@tabler/icons-react";

class ClientDetail extends Component {
	constructor(props, context) {
		super(props, context);
		this.toggleHide = this.toggleHide.bind(this);

		this.state = { clientInfoHidden: false };

		this.postEditLocation = `/clients/${this.props.match.params.id}`;
	}

	toggleHide() {
		this.setState({ clientInfoHidden: !this.state.clientInfoHidden });
	}

	componentDidMount() {
		this.props.fetchClientDetail(this.props.match.params.id);
		this.props.fetchMattersList({ clientID: this.props.match.params.id });
	}
	componentDidUpdate(prevProps) {
		if (prevProps.match.params.id !== this.props.match.params.id) {
			this.props.fetchClientDetail(this.props.match.params.id);
			this.props.fetchMattersList({
				clientID: this.props.match.params.id,
			});
		}
	}

	isActivateDeactivateDisabled() {
		return this.props.clientLifecycleStatusObject.disabled;
	}

	getMenuItems() {
		let menuItems = [
			{
				text: "Edit Client",
				href: "/clients/" + this.props.clientDetails.clientID + "/edit",
			},
		];

		if (this.props.clientDetails.clientStatus === "active") {
			menuItems.push({
				text: "Deactivate Client",
				disabled: this.isActivateDeactivateDisabled(),
				disabledHoverText:
					"Cannot deactivate a client in the Trash Bin",
				onSelect: () =>
					this.props.deactivateClient({
						clientID: this.props.clientDetails.clientID,
						location: "clientDetail",
					}),
			});
		}
		if (this.props.clientDetails.clientStatus === "inactive") {
			menuItems.push({
				text: "Activate Client",
				disabled: this.isActivateDeactivateDisabled(),
				disabledHoverText: "Cannot activate a client in the Trash Bin",
				onSelect: () =>
					this.props.activateClient({
						clientID: this.props.clientDetails.clientID,
						location: "clientDetail",
					}),
			});
		}
		if (this.props.userRights.CAN_PERMANENT_DELETE) {
			if (this.props.clientLifecycleStatusObject.IN_TRASH) {
				menuItems.push({
					text: "Restore Client from Trash Bin",
					onSelect: () =>
						this.props.setClientLifecycleStatus({
							clientIDs: [this.props.clientDetails.clientID],
							lifecycleStatus: NORMAL_LIFECYCLE_STATUS,
							location: "clientDetail",
						}),
				});
			}
			if (!this.props.clientLifecycleStatusObject.IN_TRASH) {
				menuItems.push({
					text: "Move Client to Trash Bin",
					onSelect: () =>
						this.props.setClientLifecycleStatus({
							clientIDs: [this.props.clientDetails.clientID],
							lifecycleStatus: TRASH_LIFECYCLE_STATUS,
							location: "clientDetail",
						}),
				});
			}
		}
		return menuItems;
	}

	render() {
		return (
			<div className="fullHeightFlex noDefaultMargin">
				{this.props.clientLifecycleStatusObject.IN_TRASH
					? TrashBinMessage({
							objectType: "Client",
							itemLocation:
								this.props.clientLifecycleStatusObject
									.itemLocation,
						})
					: null}
				<div
					className="clientInfoHeader"
					style={{
						position: "relative",
						padding: 16,
						display: this.state.clientInfoHidden ? "none" : "block",
					}}
				>
					<TextGrid
						numColumns={3}
						columns={[
							[
								"Client Status",

								capitalize(
									this.props.clientDetails.clientStatus
								),
							],
							[
								// the label was "Primary Attorney(s)" but changed to "Assigned Staff" per UX feedback
								// the database still stores this information in the PrimaryAttorneysForClient table
								"Assigned Staff",
								<MaximumItemsList
									maxItems={5}
									key={"primaryAttorneys"}
									items={
										this.props.clientDetails
											.primaryAttorneys
											? this.props.clientDetails.primaryAttorneys.map(
													(x) => x.displayName
												)
											: []
									}
								/>,
							],
						]}
					/>

					<div style={{ position: "absolute", top: 12, right: 12 }}>
						<DropDownButtonWithRouter
							title="Edit"
							pullRight
							menuItems={this.getMenuItems()}
						/>
					</div>
				</div>
				<MaterialTabs
					activeTab={0}
					tabs={[{ label: "Matters", url: "docs" }]}
					toggleHide={this.toggleHide}
					hidden={this.state.clientInfoHidden}
				/>

				<MattersList
					newButtonRedirectLocation={
						"/matters/new/" + this.props.clientDetails.clientID
					}
					matterFilterTabsReplacementContent={
						<div style={{ display: "flex" }}>
							<IconBriefcase
								size={24}
								style={{
									margin: "0 10px",
									alignSelf: "center",
								}}
							/>
							<h4
								style={{
									lineHeight: "normal",
									wordBreak: "break-word",
								}}
							>
								{" "}
								Matters for{" "}
								{this.props.clientDetails.clientName}
							</h4>
						</div>
					}
					postEditLocation={this.postEditLocation}
					hiddenColumns={["clientName"]}
					tabFilterOverride="All"
					onlyShowMattersForClientID={
						this.props.clientDetails.clientID
					}
					// used to differentiate between the client detail page and the global matters list
					clientName={this.props.clientDetails.clientName}
					// used to disabled the new matter button if the client is deleted
					viewingDeletedClient={
						this.props.clientLifecycleStatusObject.IN_TRASH
					}
				/>
			</div>
		);
	}
}
ClientDetail.propTypes = {
	fetchClientDetail: PropTypes.func.isRequired,
	fetchMattersList: PropTypes.func.isRequired,
	clientDetails: PropTypes.object.isRequired,
	mattersListData: PropTypes.array.isRequired,
	loading: PropTypes.bool.isRequired,
	userRights: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
	clientDetails: state.client.clientDetails,
	clientLifecycleStatusObject: getClientLifecycleStatusObject(
		state.client.clientDetails.clientLifecycleStatus
	),
	mattersListData: state.client.mattersList,
	loading: state.request.loading,
	userRights: state.user.userRights,
});
export default connect(mapStateToProps, {
	fetchClientDetail,
	fetchMattersList,
	setClientLifecycleStatus,
	activateClient,
	deactivateClient,
})(ClientDetail);
